import { getBlockTypes, getMeasurementUnits, getOverallSpectraDescription, getScanType, getUUId, getAppVersion, getFlagParameters, windowsTimeToMs, } from './maps';
import { readBytes64 } from './utilities';
/**
 * File Header parsing - First 512 bytes. The file header is the first block of the file
 * but it is different from the rest of the block headers. It has many more properties that
 * describe the file, and it is 512B long, as opposed to 16B.
 * @param buffer WDF buffer as IOBuffer i.e `new IOBuffer(file.wdf)`
 * @return File Metadata
 */
export function readFileHeader(buffer) {
    /* make sure the offset is 0 to read the file header */
    buffer.offset = 0;
    /* next we determine all the properties included in the file header */
    const signature = getBlockTypes(buffer.readUint32());
    if (signature !== 'WDF_BLOCKID_FILE') {
        throw new Error(`expected WDF_BLOCKID_FILE, got ${signature}`);
    }
    const version = buffer.readUint32();
    if (version !== 1) {
        /* we may include try block for 2>version>1.0 */
        throw new Error(`Script parses version 1. Found v.${version}`);
    }
    const fileHeaderSize = Number(buffer.readBigUint64());
    const flags = getFlagParameters(Number(buffer.readBigUint64()));
    const uuid = getUUId(buffer.readBytes(16));
    const unused0 = Number(buffer.readBigUint64());
    const unused1 = buffer.readUint32();
    const nTracks = buffer.readUint32();
    const status = buffer.readUint32();
    const nPoints = buffer.readUint32();
    const nSpectra = Number(buffer.readBigUint64());
    const nCollected = Number(buffer.readBigUint64());
    const nAccum = buffer.readUint32();
    const yListCount = buffer.readUint32();
    const xListCount = buffer.readUint32();
    const originCount = buffer.readUint32();
    const appName = buffer.readUtf8(24).replace(/\x00/g, '');
    /* tested replaceAll('\x00\','') but it is slower */
    const appVersion = getAppVersion(buffer.readBytes(8));
    const scanType = getScanType(buffer.readUint32());
    const type = getOverallSpectraDescription(buffer.readUint32());
    const timeStart = windowsTimeToMs(buffer.readBigUint64());
    const timeEnd = windowsTimeToMs(buffer.readBigUint64());
    const units = getMeasurementUnits(buffer.readUint32());
    const laserWavenum = buffer.readFloat32();
    const spare = readBytes64(buffer, 6);
    const user = buffer.readUtf8(32).replace(/\x00/g, '');
    const title = buffer.readUtf8(160).replace(/\x00/g, '');
    const padding = readBytes64(buffer, 6);
    const free = readBytes64(buffer, 4);
    const reserved = readBytes64(buffer, 4);
    const fileHeader = {
        title,
        type,
        units,
        nSpectra,
        nPoints,
        scanType,
        laserWavenum,
        yListCount,
        xListCount,
        nCollected,
        nAccum,
        originCount,
        flags,
        nTracks,
        status,
        user,
        timeStart,
        timeEnd,
        signature,
        appName,
        appVersion,
        version,
        fileHeaderSize,
        uuid,
        spare,
        unused0,
        unused1,
        padding,
        free,
        reserved,
    };
    return fileHeader;
}
//# sourceMappingURL=readFileHeader.js.map